<template>
    <div ref="soccer_team_detail_wrap" style="display: flex; flex-direction: column; position: relative; background-color: #fff; z-index:500">
        <!-- <div v-if="isShowBackgroundImage" ref="background_image" class="background_image_wrapper" style="position: fixed; left: 0; top: 0; width: 100%; height: 100%;">
            <img style="width: 100%; height: 100%;" :src="$resourcePath + soccerTeamData.image_path" alt="">
        </div> -->
        <div style="margin-top: 12px; position: relative; display: flex; margin-bottom: 16px; align-items: center; justify-content: space-between; padding: 0 12px;">
            <div style="display:flex; align-items: center; " @click="closeAction">
                <img :src="require('@/assets/img/ico-move_black.png')" style="width: 10px;">
                <span style="font-size:14px; font-weight:500; margin-left:5px; color:#210F03;">뒤로가기</span>
            </div>
            <div style="font-weight: 700; position: absolute; left: 50%; transform: translateX(-50%);">상세보기</div>
            <div @click="setIsShowPopMenu" style="display: flex; flex-direction: column; gap: 3px;">
                <div style="width: 5px; height: 5px; background-color: #210f03; border-radius: 50%;"></div>
                <div style="width: 5px; height: 5px; background-color: #210f03; border-radius: 50%;"></div>
                <div style="width: 5px; height: 5px; background-color: #210f03; border-radius: 50%;"></div>
            </div>
        </div>
        <div style="flex: 1; overflow-y: scroll; background-color: #F7F8F9;">
            <div style="height: 250px; position: relative;">
                <img style="width: 100%; height: 100%; object-fit: cover; position: absolute; z-index: 1;" :src="$resourcePath + soccerTeamData.back_image_path" alt="">
                <div style="position: relative; z-index: 2;">
                    <div style="text-align: right; padding-right: 12px; padding-top: 12px;">
                        <div style="display: inline-block; padding: 7px 12px; background-color: #FFFFFFCC; border-radius: 20px;">
                            <div style="display: flex; align-items: center; gap: 4px;">
                                <img :src="require('@/assets/img/team_star.svg')" alt="">
                                <div style="font-size: 14px;"><span style="font-weight: 700;">{{ like_cnt }}명</span>이 관심있음</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="padding: 0 12px;">
                <div style="background-color: #fff; text-align: center; padding-bottom:7px; box-shadow: 1px 1px 5px 0px #00000066; border-radius: 12px; margin-top: -83px; position: relative; z-index: 2;">
                    <div class="logo_wrapper">
                        <img style="width: 100%;" :src="$resourcePath + soccerTeamData.image_path" alt="">
                    </div>
                    <div style="padding-top: 44px;">
                        <div style="font-weight: 700; font-size: 24px; line-height: 24px; margin-bottom: 4px;">{{ soccerTeamData.name }}</div>
                        <div style="display: flex; gap: 8px; justify-content: center; margin-top: 5px;">
                            <div style="padding: 0 7px; line-height: 20px; font-size: 12px; border-radius: 8px; background-color: var(--color-main); color: #fff;">{{ soccerTeamData.age }}</div>
                            <div style="padding: 0 7px; line-height: 20px; font-size: 12px; border-radius: 8px; background-color: var(--color-main); color: #fff;">{{ soccerTeamData.type }}</div>
                        </div>
                        <div style="display: flex; justify-content: center; align-items: center; gap: 4px; padding: 0 12px; margin-top: 5px;">
                            <template v-if="soccerTeamData.recent_result">
                                <img style="width: 11px;" :src="require('@/assets/img/leaf.png')" alt="">
                                <div style="font-weight: 500; font-size: 14px; line-height: 24px; word-break: break-all;">{{ soccerTeamData.recent_result }}</div>
                                <img style="width: 11px; transform: rotateY(180deg)" :src="require('@/assets/img/leaf.png')" alt="">
                            </template>
                        </div>
                    </div>

                    <div style="margin-top: 7px;" v-if="soccerTeamData.career_prize">
                        <div v-if="is_show_career_prize" @click="toggleCareerPrize" style="color:#4B8AFF;font-size:14px; display:flex; align-items: center; justify-content: center; padding:5px 0px;">접기<img :src="require('@/assets/img/blue_down_arrow.png')" style="width:11px; height:6px; margin-left:5px; transform: rotate(180deg)"></div>
                        <div v-else @click="toggleCareerPrize" style="color:#4B8AFF; font-size:14px; display:flex; align-items: center; justify-content: center; padding:5px 0px;">수상 이력 보기<img :src="require('@/assets/img/blue_down_arrow.png')" style="width:11px; height:6px; margin-left:5px;"></div>

                        <div :style="{ gridTemplateRows: is_show_career_prize ? '1fr' : '0fr' }" style=" display:grid; transition: 0.3s grid-template-rows;">
                            <div style="overflow:hidden;">
                                <div v-for="each, i in soccerTeamData.career_prize.split('||')" :key="i" :style="{ marginTop: i === 0 ? '' : '' }">
                                    <div style="font-size:14px; font-weight:500; color:#210F03; line-height: 32px; padding: 0 12px;">{{ each }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style=" padding-top: 16px;">
                <div style="display: flex; padding: 0 12px;">
                    <div :class="curTab === CUR_TAB.INFO ? 'active' : ''" @click="setCurTab(CUR_TAB.INFO)" class="tab_btn">정보</div>
                    <div :class="curTab === CUR_TAB.MANAGER ? 'active' : ''" @click="setCurTab(CUR_TAB.MANAGER)" class="tab_btn">지도자</div>
                </div>
            </div>
            <template v-if="curTab === CUR_TAB.INFO">
                <div style="padding: 0 12px;">
                    <div style="margin-top: 32px; position: relative; background-color: #0f1216; border-radius: 12px; padding: 0 12px; padding-top: 23px; height: 108px; display: flex; flex-direction: column; align-items: center;">
                        <div style="position: absolute; top: 7px; left: 15px; z-index: 1;">
                            <img style="width: 47px;" :src="require('@/assets/img/quotes_icon.png')" alt="">
                        </div>
                        <div style="position: absolute; bottom: 7px; right: 15px; z-index: 1;">
                            <img style="width: 47px; transform: rotate(180deg);" :src="require('@/assets/img/quotes_icon.png')" alt="">
                        </div>
                        <div style="position: relative; z-index: 2; text-align: center;">
                            <div style="font-weight: 700; font-size: 14px; color: var(--color-main); line-height: 20px;">About the Team</div>
                            <div v-if="soccerTeamData.team_introduce" style="margin-top: 15px; color: #fff; font-weight: 700; line-height: 16px;">{{ soccerTeamData.team_introduce }}</div>
                            <div v-else style="margin-top: 4px; color: #fff; text-align: center;">
                                <div style="font-weight: 700; line-height: 24px;">아직 팀 소개가 없어요</div>
                                <div style="font-weight: 500; font-size: 12px; line-height: 24px;">감독님이 멋진 팀의 비전을 준비하고 계실 거예요.</div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 32px;" class="common_box_shadow">
                        <div class="title">주요 정보</div>
                        <div style="margin-top: 12px; display: flex; flex-direction: column; gap: 12px;">
                            <div
                                v-for="item, i in mainInfo"
                                :key="i + 'mainInfo'"
                                class="main_info_item"
                                :class="{ opened: openedMainInfoIndex === i }"
                                @click="toggleMainInfo(i)"
                            >
                                <div class="main_info_header">
                                    <div style="width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; background-color: #F8F9FA; border: 1px solid #6A6A6A1A; border-radius: 4px;">
                                        <img style="width: 12px;" :src="item.image_path" alt="">
                                    </div>
                                    <div style="font-weight: 700; font-size: 12px; line-height: 16px; flex: 1;">{{ item.title }}</div>
                                    <div>
                                        <img
                                            class="main_info_arrow"
                                            :class="{ opened: openedMainInfoIndex === i }"
                                            style="width: 6px;"
                                            :src="require('@/assets/img/arrow_gray_new.png')"
                                            alt=""
                                        >
                                    </div>
                                </div>
                                <div
                                    class="main_info_body"
                                    :style="{ gridTemplateRows: openedMainInfoIndex === i ? '1fr' : '0fr' }"
                                >
                                    <div style="overflow: hidden;">
                                        <div class="main_info_divider"></div>
                                        <div class="main_info_contents">
                                            <template v-if="item.contents.length > 0">
                                                <span style="font-size: 15px;"
                                                    v-for="detail, detailIndex in item.contents"
                                                    :key="detailIndex + 'detail2'"
                                                >{{ detail }}<span v-if="detailIndex !== item.contents.length - 1">, </span></span>
                                            </template>
                                            <template v-else>
                                                아직 팀에서 내용을 등록하지 않았어요.
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 32px;" class="common_box_shadow">
                        <div style="display: flex; align-items: center; gap: 5px;">
                            <img style="width: 16px;" :src="require('@/assets/img/introduce_team.png')" alt="">
                            <div class="title">지도 목표</div>
                        </div>
                        <div v-if="instruct_goal.length > 0" style="margin-top: 15px; display: flex; flex-direction: column; gap: 15px;">
                            <div v-for="each, i in instruct_goal" :key="i + 'instruct_goal'"  style="display: flex; align-items: center; gap: 10px;">
                                <div class="lead_goal">{{ i + 1 }}</div>
                                <div style="font-weight: 700; font-size: 12px; line-height: 24px;">{{ each }}</div>
                            </div>
                        </div>
                        <div style="margin-top: 15px;" v-else>
                            <div style="text-align: center; font-weight: 700; font-size: 12px; color: #808080; line-height: 24px;">아직 팀에서 지도 목표를 작성하지 않았어요</div>
                        </div>
                    </div>
                    <div style="margin-top: 32px;">
                        <div class="common_box_shadow">
                            <div style="display: flex; justify-content: space-between;">
                                <div style="display: flex; align-items: center; gap: 6px;">
                                    <div class="title">감독</div>
                                </div>
                                <div class="show_whole">
                                    <div @click="setCurTab(CUR_TAB.MANAGER)" style="color: var(--color-main);">상세 보기</div>
                                    <div>
                                        <img style="width: 6px;" :src="require('@/assets/img/arrow_orange_new.png')" alt="">
                                    </div>
                                </div>
                            </div>
                            <div v-if="Object.keys(soccerTeamData).length > 0" style="margin-top: 10px; padding: 12px 16px; border-radius: 12px; border: 1px solid #D9D9D9;">
                                <div style="display: flex; gap: 13px;">
                                    <div style="width: 80px; height: 80px; flex-shrink: 0; border-radius: 12px; background-color: #d9d9d9; overflow: hidden;">
                                        <ProfileImage style="width: 100%;" :isWithoutRadius="true" :imagePath="soccerTeamData.manager.image_path"></ProfileImage>
                                    </div>
                                    <div>
                                        <div style="display: flex; gap: 4px; align-items: center;">
                                            <div style="font-weight: 700; line-height: 20px;">{{ soccerTeamData.manager.nic_name }}</div>
                                            <div>
                                                <img style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                            </div>
                                        </div>
                                        <ul style="margin-top: 0; padding-left: 24px; margin-top: 4px; margin-bottom: 0;">
                                            <li style="font-size: 12px; font-weight: 500; color: #808080; line-height: 16px; margin-bottom: 5px;">{{ soccerTeamData.manager.licenses }}</li>
                                            <li v-for="each, i in showCareerList" :key="i + 'show_career'" style="font-size: 12px; font-weight: 500; color: #808080; line-height: 16px; margin-bottom: 5px;">{{ each.replaceAll(SHOW_TOKEN, '') }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 32px;" class="common_box_shadow">
                            <div style="padding-bottom: 12px; border-bottom: 1px solid #d9d9d9;">
                                <div style="font-weight: 700; line-height: 24px;">{{ soccerTeamData.manager ? soccerTeamData.manager.nic_name : '' }} 감독이 찾고 있는 선수 🔍</div>
                                <div style="margin-top: 4px; font-size: 14px; font-weight: 500; line-height: 24px; color: #808080;">선수 스카웃 조건을 확인하세요</div>
                                <div v-if="scoutCondition.length > 0" style="margin-top: 12px; display: flex; flex-direction: column; gap: 12px;">
                                    <div v-for="each, i in scoutCondition" :key="i + 'condition'" style="display: flex; align-items: center; gap: 5px; padding: 10px 7px; background-color: #F8F9FA; border-radius: 8px;">
                                        <div style="width: 17px; height: 17px; border-radius: 50%; display: flex; justify-content: center; align-items: center; background-color: var(--color-main);">
                                            <img style="width: 9px;" :src="require('@/assets/img/white_check.png')" alt="">
                                        </div>
                                        <div style="font-weight: 500; font-size: 14px; line-height: 20px;">{{ each }}</div>
                                    </div>
                                </div>
                                <div v-else style="height: 60px; margin-top: 12px; display: flex; align-items: center; justify-content: center; background-color: #F8F9FA; border-radius: 8px;">
                                    <div style="font-weight: 500; font-size: 14px;">아직 감독님이 작성하지 못하셨어요</div>
                                </div>
                            </div>
                            <div style="padding-top: 12px;">
                                <div style="font-weight: 700; line-height: 24px;">이런 능력을 갖추면 좋습니다 💁‍♂️‍</div>
                                <div style="margin-top: 4px; font-size: 14px; font-weight: 500; line-height: 24px; color: #808080;">입단 테스트에서 가장 중요하게 평가하는 개인 기량</div>
                                <div v-if="mainEvaluation.length > 0" style="margin-top: 12px; display: flex; flex-wrap: wrap; gap: 12px 7px;">
                                    <div v-for="each, i in mainEvaluation" :key="i + 'evaluation'" style="padding: 4px 12px; background-color: #ECF5FF; border-radius: 23px;">
                                        <div style="font-weight: 700; font-size: 14px; color: #1945d3; line-height: 24px;"># {{ each }}</div>
                                    </div>
                                </div>
                                <div v-else style="margin-top: 12px; display: flex; flex-direction: column; align-items: center; background-color: #F8F9FA; border-radius: 8px; padding: 20px 0;">
                                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 10px;">아직 감독님이 세부 능력을 작성하지 않으셨어요</div>
                                    <div style="font-weight: 500; font-size: 14px; line-height: 20px; color: #606060; text-align: center;">대신 먼저 입단 요청서를 보내고<br>감독님께 직접 어필해 보는 건 어떨까요?</div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 32px;">
                            <div style="font-weight: 700; line-height: 24px;">감독 인터뷰</div>
                            <div style="font-size: 14px; font-weight: 500; line-height: 24px; color: #808080;">감독님의 이야기를 만나보세요</div>
                            <div v-if="soccerTeamData.interview_youtube_link" style="margin-top: 5px; border-radius: 12px; overflow: hidden; border: 4px solid var(--color-main);">
                                <ContentsViewer :pageType="'soccer_team'" :contents="soccerTeamData.interview_youtube_link" style="" />
                            </div>
                        </div>
                        <div style="font-weight: 700; font-size: 16px; margin-top: 32px; display: flex; gap: 12px;">
                            <div>장소</div>
                            <div style="font-weight: 500; font-size: 16px;">
                                <div>{{ team_place ? team_place.name : '' }}</div>
                                <div style="font-size: 13px;line-height: 20px; margin-top: 3px; color: #606060;">{{ team_place ? team_place.address : '' }}</div>
                            </div>
                            <div style="flex:1;"></div>
                            <div style="" @click="showInBrowser">
                                <div style="padding:0px 0px 5px 10px; color:var(--color-main); ">길찾기</div>
                            </div>
                        </div>
                        <div style="margin-top: 5px; margin-bottom: 103px;">
                            <div id="place_map" style="height: 156px; border-radius: 12px; "></div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="curTab === CUR_TAB.MANAGER">
                <div style="padding: 0 12px;">
                    <div style="margin-top: 17px; border-radius: 12px; background-color: #FFF7ED; border: 1px solid #FFEACF; padding: 24px 20px; display: flex; flex-direction: column; align-items: center;">
                        <div style="width: 100px;">
                            <ProfileImage style="width: 100%;" :imagePath="soccerTeamData.manager.image_path"></ProfileImage>
                        </div>
                        <div style="font-size: 20px; font-weight: 700; line-height: 24px; margin-top: 10px;">{{ soccerTeamData.manager.nic_name }}</div>
                        <div style="font-weight: 700; color: var(--color-main); line-height: 24px;">Head Coach</div>
                        <div style="margin-top: 20px; background-color: #FFECDF; border-radius: 12px; padding: 12px; width: 100%;">
                            <div v-if="soccerTeamData.manager_introduce" style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ soccerTeamData.manager_introduce }}</div>
                            <div v-else style="font-weight: 500; font-size: 14px; line-height: 24px; text-align: center; color: #808080;">아직 감독님이 소개를 작성하지 않으셨어요</div>
                        </div>
                    </div>
                    <div class="common_box_shadow" style="margin-top: 20px;">
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <img style="width: 16px;" :src="require('@/assets/img/career_orange.png')" alt="">
                            <div class="title">지도자 경력</div>
                        </div>
                        <div v-if="coachCareer.length > 0" style="margin-top: 15px;">
                            <div v-for="career, i in coachCareer" :key="i + 'career_item'" style="display: flex; margin-bottom: 10px; align-items: center; gap: 10px;">
                                <div style="border: 1px solid var(--color-main); width: 9px; height: 9px; border-radius: 50%; position: relative;">
                                    <div v-if="i === 0" class="border_top"></div>
                                    <div v-if="i < coachCareer.length - 1" class="border_common"></div>
                                    <div v-else class="border_bottom"></div>
                                </div>
                                <div 
                                    style="font-weight: 700; font-size: 12px; line-height: 24px;" 
                                    :set="detail_arr = career.split('(')">{{ detail_arr[0].replaceAll(SHOW_TOKEN, '') }}
                                    <span v-if="detail_arr[1]" style="font-weight: 500; font-size: 12px; color: #808080;">({{ detail_arr[1].replaceAll(SHOW_TOKEN, '') }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-else style="height: 69px; margin-top: 15px; border-radius: 12px; border: 1px dashed #cccccc; display: flex; align-items: center; justify-content: center; background-color: #f8f9fa;">
                            <div style="font-weight: 600; font-size: 14px; color: #808080;">등록된 지도자 경력이 없습니다.</div>
                        </div>
                    </div>
                    <div class="common_box_shadow" style="margin-top: 20px;">
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <img style="width: 20px;" :src="require('@/assets/img/player_career_orange.png')" alt="">
                            <div class="title">선수 경력</div>
                        </div>
                        <div v-if="playerCareer.length > 0" style="margin-top: 15px;">
                            <div v-for="career, i in playerCareer" :key="i + 'career_item'" style="display: flex; margin-bottom: 10px; align-items: center; gap: 10px;">
                                <div style="border: 1px solid var(--color-main); width: 9px; height: 9px; border-radius: 50%; position: relative;">
                                    <div v-if="i === 0" class="border_top"></div>
                                    <div v-if="i < playerCareer.length - 1" class="border_common"></div>
                                    <div v-else class="border_bottom"></div>
                                </div>
                                <div 
                                    style="font-weight: 700; font-size: 12px; line-height: 24px;" 
                                    :set="detail_arr = career.split('(')">{{ detail_arr[0].replaceAll(SHOW_TOKEN, '') }}
                                    <span v-if="detail_arr[1]" style="font-weight: 500; font-size: 12px; color: #808080;">({{ detail_arr[1].replaceAll(SHOW_TOKEN, '') }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-else style="height: 69px; margin-top: 15px; border-radius: 12px; border: 1px dashed #cccccc; display: flex; align-items: center; justify-content: center; background-color: #f8f9fa;">
                            <div style="font-weight: 600; font-size: 14px; color: #808080;">등록된 선수 경력이 없습니다.</div>
                        </div>
                    </div>
                    <div style="margin-top: 20px; margin-bottom: 100px;">
                        <div style="background-color: #FFFAF5; border-radius: 12px; border: 1px solid #ffeacf; padding: 20px 24px;">
                            <div v-if="parseInt(soccerTeamData.coaches_cnt) > 0" style="display: flex; gap: 6px;">
                                <div style="width: 40px; height: 40px; border: 1px solid #ffeacf; background-color: #fff; border-radius: 50%; display: flex; justify-content: center; align-items: center;">
                                    <img style="width: 23px;" :src="require('@/assets/img/expert_coaches.png')" alt="">
                                </div>
                                <div>
                                    <div style="font-weight: 700; font-size: 12px; line-height: 20px;">총 {{ soccerTeamData.coaches_cnt }}명의 전문 코치진</div>
                                    <div v-for="each, i in coaches" :key="i + 'coaches'" style="padding: 2px 8px; display: inline-block; margin-right: 9px; border-radius: 8px; border: 1px solid #ffeacf; background-color: #fff; color: #808080; line-height: 16px; font-size: 12px;">
                                       {{ each }}
                                    </div>
                                </div>
                            </div>
                            <div style="" v-else>
                                <div style="display: flex; justify-content: center;">
                                    <div style="width: 40px; height: 40px; border: 1px solid #ffeacf; background-color: #fff; border-radius: 50%; display: flex; justify-content: center; align-items: center;">
                                        <img style="width: 23px;" :src="require('@/assets/img/expert_coaches.png')" alt="">
                                    </div>
                                </div>
                                <div style="margin-top: 5px; font-weight: 700; font-size: 12px; line-height: 20px; text-align: center;">등록된 추가 코치진이 없습니다.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div style="margin-top: 10px; display: flex; gap: 8px; padding: 0 12px; margin-bottom: 22px;">
                    <div @click="$Util.showProfile(soccerTeamData.manager.idx)" style="display: flex; flex-direction: column; align-items: center;">
                        <div style="width: 128px; height: 168px; border-radius: 10px; overflow: hidden; border: 1px solid #d9d9d9;">
                            <img style="object-fit: cover; width: 100%; height: 100%;" v-if="Object.keys(soccerTeamData).length > 0" :src="$resourcePath + soccerTeamData.manager.image_path" alt="">
                        </div>
                        <div style="display: flex; align-items: center; margin-top: 8px; gap: 8px;">
                            <div style="font-weight: 500; font-size: 14px; color: #606060;">감독</div>
                            <div @click="$Util.showProfile(soccerTeamData.manager.idx)" style="display: flex; align-items: center; gap: 4px; line-height: 20px; font-weight: 700;">
                                <div>{{ soccerTeamData.manager ? soccerTeamData.manager.nic_name : '' }}</div>
                                <img v-if="soccerTeamData.type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                            </div>
                        </div>
                    </div>
                    <div style="">
                        <div style="display: flex; gap: 8px;">
                            <div style="font-size: 14px; font-weight: 500; color: #606060; line-height: 24px; flex-shrink: 0;">경력</div>
                            <div>
                                <div v-for="career, i in careerList" :key="i" style="display: flex; gap: 8px;">
                                    <div>
                                        <div v-for="detail, i in career.contents" :key="i + 'detail'" style="font-weight: 700; line-height: 24px; font-size: 14px;" :set="detail_arr = detail.split('(')">{{ detail_arr[0] }}<span v-if="detail_arr[1]" style="color:#808080; font-size:12px; font-weight:500;">({{ detail_arr[1] }}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </template>
        </div>
        <div v-if="$GlobalStore.isLogin() && $GlobalStore.loginInfo().is_temp_coach == 0" style="height: 91px; width: 100%; bottom: 0; position: absolute; background-color: transparent;">
            <div style="display: flex; gap: 9px; margin-top: 8px; padding: 0 12px;">
                <InteractionOfScale :scaleNumber="'0.96'" style="flex: 1;">
                    <div @click="handleLikeFunction" :class="$GlobalStore.loginInfo().is_temp_coach == '1' ? 'coach_class' : 'common_class'">
                        <img v-if="!is_me_liked" style="width: 16px" :src="require('@/assets/img/star_black.png')" alt="">
                        <img v-else style="width: 16px" :src="require('@/assets/img/like_star.png')" alt="">
                        <div>팀 응원하기</div>
                    </div>
                </InteractionOfScale>
                <InteractionOfScale :scaleNumber="'0.96'" style="flex: 1;" v-if="is_temp_coach">
                    <div @click="sendRequestFormConfirm" style="flex: 1; height: 60px; gap: 4px; display: flex; justify-content: center; align-items: center; border-radius: 50px; font-size: 14px; font-weight: 700; background-color: #210f03; color: var(--color-main);">
                        <img style="width: 16px" :src="require('@/assets/img/dm_main_color.png')" alt="">
                        <div>입단 요청서 보내기</div>
                    </div>
                </InteractionOfScale>
            </div>
        </div>
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="menuOptions"></BottomPopupMenu>
        <BookmarkPopup :height="254" :isShowBookmarkPopup="isShowRequestConfirmPopup" :closeBookmarkPopup="closeRequestConfirmPopup">
            <div>
                <div @click="closeRequestConfirmPopup" style="font-weight: 700;">닫기</div>
                <div v-if="isExistSoccerhow" style="margin-top: 20px; font-size: 20px; line-height: 33px; font-weight: 700; text-align: center;">보고 계신 축구팀에<br>직접 입단 요청서를 보낼까요?</div>
                <div v-else style="margin-top: 20px; font-size: 20px; line-height: 33px; font-weight: 700; text-align: center;">만들어둔 입단 요청서가 없어요<br>새로 만들어야 해요</div>
                <div v-if="isExistSoccerhow" @click="sendRequestForm" style="width: 255px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">네, 직접 보낼게요</div>
                <div v-else @click="showRequestJoinForm" style="width: 255px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">입단 요청서 만들기</div>
            </div>
        </BookmarkPopup>
        <CommonPopupFrame :isBlur="true" background="#fffc" :changeBottom="0" :changeHeight="100" :isOpen="isShowRequestForm" :closeCompleteAction="closeRequestForm">
            <div @click="closeRequestForm" style="padding: 16px 20px; font-weight: 700; width: 100px;">닫기</div>
            <div style="flex: 1; overflow-y: scroll; padding: 0 12px;">
                <div style="text-align: center; margin-top: 60px; font-size: 20px; font-weight: 700; line-height: 33px; margin-bottom: 40px;">아래의 요청서를 전달할게요</div>
                <div style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px; border-radius: 12px;" v-if="Object.keys(requestInfo).length > 0">
                    <CommonPost :hideOption="true" :isDetail="true" :isFeed="true" :soccerHows="requestInfo"></CommonPost>
                </div>
            </div>
            <div style="padding: 0 12px;">
                <div @click="showPayForm" style="margin-bottom: 40px; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">보내기</div>
            </div>
        </CommonPopupFrame>
        <BookmarkPopup :background="'#fff'" :height="280" :isShowBookmarkPopup="isShowBookmarkPopupReport" :closeBookmarkPopup="closeBookmarkPopup">
            <div>
                <div @click="closeBookmarkPopup" style="font-weight: 700;">닫기</div>
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 20px; line-height: 24px; margin-top: 12px;">게시물을 신고할까요?</div>
                    <div style="margin-top: 20px; color: #606060; font-weight: 500; line-height: 24px;">좋지 않은 게시물을 신고할 수 있습니다.<br>신고를 진행할까요?</div>
                    <div @click="report" style="width: 210px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">신고하기</div>
                </div>
            </div>
        </BookmarkPopup>
        <MakeRequestJoinForm :isShowMakeRequestJoinForm="isShowMakeRequestJoinForm" :closeRequestJoinForm="closeRequestJoinForm"></MakeRequestJoinForm>
    </div>
</template>

<script>
import MakeRequestJoinForm from '@/components/soccerhowmain/MakeRequestJoinForm'
import ResponseCode from '@/ResponseCode'
import { SOCCER_HOW_TYPE, REPORT_TYPE_IDX } from '@/Constants'
import {MAIN_TYPE, PUSH_ACTION, SOCCER_HOW_TEAM_DETAIL_FROM_SCREEN, TEAM_TYPE, TRIGGER_TYPE} from "../../Constants";
import CommonPost from '@/components/soccerhowmain/CommonPost'
import ContentsViewer from '@/components/common/ContentsViewer';
import ProfileImage from '@/components/common/ProfileImage';
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import BottomPopupMenu from '@/components/common/BottomPopupMenu'
import BookmarkPopup from '@/components/soccerhowmain/BookmarkPopup';
import InteractionOfScale from '@/components/common/InteractionOfScale';
import NaverMap from '@/modules/NaverMap';

const CUR_TAB = {
    INFO: '정보',
    MANAGER: '지도자'
}

const SHOW_TOKEN = '[[SHOW]]'

export default {
    name: 'SoccerTeamDetail',
    components: {
        ContentsViewer, BottomPopupMenu, BookmarkPopup, InteractionOfScale, CommonPopupFrame, CommonPost, ProfileImage,
        MakeRequestJoinForm,
    },
    props: {
        backgroundImagePath: {
            type: String,
            default: ''
        },
        teamIdx: {
            type: [String, Number],
            default: -1
        },
        from_screen: {
            type: Number,
            default: SOCCER_HOW_TEAM_DETAIL_FROM_SCREEN.DEFAULT
        },
        completeAction: {
            type: Function,
            default: () => { }
        }
    },
    computed: {
        is_temp_coach() {
            return this.$GlobalStore.loginInfo().is_temp_coach != '1'
        }
    },
    data() {
        return {
            SHOW_TOKEN: SHOW_TOKEN,
            instruct_goal: [],
            CUR_TAB: CUR_TAB,
            TEAM_TYPE: TEAM_TYPE,
            soccerTeamData: {},
            careerList: [
                { title: '감독', contents: [], key: 'career_manager' },
                { title: '코치', contents: [], key: 'career_coach' },
                { title: '선수', contents: [], key: 'career_player' },
            ],
            mainInfo: [
                { image_path: require('@/assets/img/style.png'), title: '전술 스타일', contents: [], key: 'tactic_style' },
                { image_path: require('@/assets/img/selection.png'), title: '선발 기준', contents: [], key: 'start_crit' },
                { image_path: require('@/assets/img/philosophy.png'), title: '지도 철학', contents: [], key: 'instruct_philosophy' },
                { image_path: require('@/assets/img/experience.png'), title: '유소년 지도 경험', contents: [], key: 'youth_experience' },
                { image_path: require('@/assets/img/result.png'), title: '주요 지도 성과', contents: [], key: 'main_result' },
                { image_path: require('@/assets/img/license.png'), title: '지도자 라이센스', contents: [], key: 'license' },
            ],
            scoutCondition: [],
            mainEvaluation: [],
            intervalId: null,
            isShowPopMenu: false,
            menuOptions: {},
            is_me_liked: false,
            like_cnt: 0,
            isShowRequestConfirmPopup: false,
            isShowRequestForm: false,
            SOCCER_HOW_TYPE: SOCCER_HOW_TYPE,
            requestInfo: {},
            isExistSoccerhow: false,
            isShowBookmarkPopupReport: false,
            is_show_career_prize: false,
            isShowMakeRequestJoinForm: false,
            isShowBackgroundImage: false,
            isShowContents: false,
            naverMap: null,
            team_place: {},
            curTab: CUR_TAB.INFO,
            coachCareer: [],
            playerCareer: [],
            showCareerList: [],
            screen_stay_settimeout : null,
            openedMainInfoIndex: null
        }
    },
    beforeDestroy() {
        if(this.screen_stay_settimeout) clearTimeout(this.screen_stay_settimeout);
    },
    methods: {
        toggleMainInfo(index) {
            this.openedMainInfoIndex = this.openedMainInfoIndex === index ? null : index
        },
        setCurTab(tab) {
            this.curTab = tab
            if (this.curTab === CUR_TAB.INFO) {
                this.setMap();
            }
        },
        showInBrowser() {
            this.$Util.sendEventClick('축구팀상세-길찾기');

            const latitude = this.team_place.gps_latitude;
            const longitude = this.team_place.gps_longitude;

            const url = `https://map.naver.com?lat=${latitude}&lng=${longitude}&title=${encodeURIComponent(this.team_place.name)}`;
            this.$Util.showBrowser(url);
        },
        setMap() {
            this.$nextTick(() => {
                this.naverMap = new NaverMap();
                const options = {
                    pinchZoom: false,
                    scrollWheel: false,
                    draggable: false,
                };

                const latitude = this.team_place.gps_latitude;
                const longitude = this.team_place.gps_longitude;

                this.naverMap.initMap('place_map', latitude, longitude, options);
                this.naverMap.setCenterMarker(latitude, longitude);
            })
        },
        closeAction() {
            // this.isShowBackgroundImage = false
            this.$GlobalStore.closeLastModal()
        },
        setBackgroundImage() {
            if (this.$GlobalStore.isLogin()) {
                this.$nextTick(() => {
                    const imageUrl = this.$resourcePath + this.soccerTeamData.image_path
                    this.$refs.background_image.style.backgroundImage = `url('${imageUrl}')`;
                })
            }
        },
        showRequestJoinForm() {
            this.$GlobalStore.addModal('SelectPlayerType')
            // this.isShowRequestConfirmPopup = false;
            // this.isShowMakeRequestJoinForm = true;
        },
        closeRequestJoinForm(some, insert_soccerhow_idx) {
            if (insert_soccerhow_idx) {
                this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_TEAM_JOINING, isModalBackTransparent: true, isExpert: (this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().is_temp_coach == '1'), soccerhowIdx: insert_soccerhow_idx })
            }
            this.isShowMakeRequestJoinForm = false;
        },
        toggleCareerPrize() {
            this.is_show_career_prize = !this.is_show_career_prize;
        },
        closeBookmarkPopup() {
            this.isShowBookmarkPopupReport = false
        },
        report() {
            this.$Util.sendEventClick('지도_팀신고')
            this.$GlobalStore.addModal('ReportPopup',
                {
                    target_member_idx: this.soccerTeamData.manager_idx,
                    target_member_type: '1',
                    refer_type: REPORT_TYPE_IDX.SOCCERHOW_ANYONE,
                    refer_idx: this.soccerTeamData.idx,
                    report_title: this.soccerTeamData.name,
                    report_contents: this.soccerTeamData.type
                }
            );
        },
        showPayForm() {
            this.$GlobalStore.addModal('RequestPayForm', { selectedTeam: this.soccerTeamData, soccerhowIdx: this.requestInfo.idx, isFromTeam: true })
        },
        closeRequestForm() {
            this.isShowRequestForm = false
        },
        async sendRequestForm() {
            const parameters = {};
            parameters.team_idx = this.soccerTeamData.idx;
            const res = await this.$Axios.get('/api/soccerhow/reporting/target_team', { params: parameters });
            if (res.data.direct_message) {
                this.$GlobalStore.addModal('RequestReportDetail', { soccerhowIdx: res.data.direct_message.refer_idx })
            } else {
                this.isShowRequestForm = true
            }
        },
        sendRequestFormConfirm() {
            this.confirmMySoccerhow()
        },
        async confirmMySoccerhow() {
            if (this.from_screen === SOCCER_HOW_TEAM_DETAIL_FROM_SCREEN.DEFAULT) {
                console.log('default');
                const parameters = {}
                const types = [SOCCER_HOW_TYPE.SC_COUNSEL, SOCCER_HOW_TYPE.SC_JOIN, SOCCER_HOW_TYPE.SC_JOB]
                parameters.types = types

                const res = await this.$Axios.get('/api/soccerhow/mine', { params: parameters })
                if (res.data.soccerhows.length === 0) {
                    this.isExistSoccerhow = false
                } else {
                    this.isExistSoccerhow = true
                    this.requestInfo = res.data.soccerhows[0]
                }
                this.isShowRequestConfirmPopup = true
            } else if (this.from_screen === SOCCER_HOW_TEAM_DETAIL_FROM_SCREEN.FROM_REQUEST_JOIN_TEAM_SELECTOR) {
                console.log('fromSelector');
                this.completeAction();
                this.$GlobalStore.closeLastModal();
            }
        },
        closeRequestConfirmPopup() {
            this.requestInfo = {}
            this.isShowRequestConfirmPopup = false
        },
        handleLikeFunction() {
            this.$Util.sendEventClick('축구팀상세_관심', true)
            if (this.is_me_liked) {
                this.unLikeTeam()
            } else {
                this.likeTeam()
            }
        },
        async likeTeam() {
            const formData = new FormData()
            formData.append('target_idx', this.soccerTeamData.idx)

            const res = await this.$Axios.post('/api/like/team/save', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.is_me_liked = true
                this.like_cnt++
            }
        },
        async unLikeTeam() {
            const formData = new FormData()
            formData.append('target_idx', this.soccerTeamData.idx)

            const res = await this.$Axios.post('/api/like/team/delete', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.is_me_liked = false
                this.like_cnt--
            }
        },
        shareTeamDetail() {
            const message = '';
            let url = ''

            if (process.env.NODE_ENV === 'development') {
                url = 'http://192.168.0.203:8080';
            } else {
                if (process.env.VUE_APP_IS_TEST_SERVER !== undefined) {
                    url = 'https://obyungear-user-test.ubiplus.co.kr';
                } else {
                    url = 'https://app.soccerhow.com';
                }
            }

            url += '/team_detail?idx=' + this.soccerTeamData.idx;
            console.log(url);
            const device = this.$cookies.get('device');
            if (device === 'android') {
                const text = (message === "" ? "" : message + "\n") + url;
                window.Android.shareUrl(text);
            } else if (device === 'ios') {
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'shareUrl', text: message, url: url });
            }
            this.$Util.sendEventClick("축구팀상세_공유하기", true)
        },
        setIsShowPopMenu() {
            this.isShowPopMenu = true
            const labelAndAction = []
            labelAndAction.push(
                // {
                //     label: '신고하기', action: () => {
                //         this.isShowBookmarkPopupReport = true
                //         this.isShowPopMenu = false
                //     },
                // },
                {
                    label: '공유하기', action: () => {
                        this.shareTeamDetail();
                        this.isShowPopMenu = false
                    },
                },
            )

            this.menuOptions = {
                labelAndAction: labelAndAction,
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }
        },
        async getSoccerTeamDetail() {
            const parameters = {}
            parameters.team_idx = this.teamIdx

            const res = await this.$Axios.get('/api/team/detail', { params: parameters })
            if (!res.data.team) {
                this.$GlobalStore.showAlert('삭제된 팀입니다.');
                this.$GlobalStore.closeLastModal();
                return;
            }
            this.soccerTeamData = res.data.team
            this.is_me_liked = this.soccerTeamData.is_me_liked
            this.like_cnt = parseInt(this.soccerTeamData.like_cnt)
            const careerKeys = ['career_manager', 'career_coach', 'career_player']
            const mainInfoKeys = ['license', 'tactic_style', 'start_crit', 'instruct_philosophy', 'main_result', 'youth_experience']
            this.classificationData(careerKeys, this.careerList)
            this.classificationData(mainInfoKeys, this.mainInfo)
            this.instruct_goal = this.soccerTeamData.instruct_goal.split('||')
            this.coaches = (this.soccerTeamData.coaches ?? '').split('||')
            const playerCareer = this.soccerTeamData.career_player.split('||')
            let coachCareer
            if (this.soccerTeamData.career_coach) {
                coachCareer = this.soccerTeamData.career_manager.split('||').concat(this.soccerTeamData.career_coach.split('||'))
            } else {
                coachCareer = this.soccerTeamData.career_manager.split('||')
            }
            this.coachCareer = coachCareer
            this.playerCareer = playerCareer
            this.showCareerList = this.coachCareer.concat(this.playerCareer).filter(each => each.includes(SHOW_TOKEN))

            if (this.soccerTeamData.scout_condition) {
                if (this.soccerTeamData.scout_condition.includes('||')) {
                    this.scoutCondition = this.soccerTeamData.scout_condition.split('||')
                } else {
                    this.scoutCondition.push(this.soccerTeamData.scout_condition)
                }
            }

            if (this.soccerTeamData.main_evaluation) {
                if (this.soccerTeamData.main_evaluation.includes('||')) {
                    this.mainEvaluation = this.soccerTeamData.main_evaluation.split('||')
                } else {
                    this.mainEvaluation.push(this.soccerTeamData.main_evaluation)
                }
            }
            this.team_place = this.soccerTeamData.place;
            this.setMap();
        },
        classificationData(keyValueList, classificationArr) {
            keyValueList.forEach(keyValue => {
                if (this.soccerTeamData[keyValue]) {
                    if (this.soccerTeamData[keyValue].includes('||')) {
                        const converToArr = this.soccerTeamData[keyValue].split('||')
                        classificationArr.forEach(item => {
                            if (item.key === keyValue) {
                                item.contents = converToArr
                            }
                        })
                    } else {
                        classificationArr.forEach(item => {
                            if (item.key === keyValue) {
                                item.contents.push(this.soccerTeamData[keyValue])
                            }
                        })
                    }
                }
            })
        }
    },
    mounted() {
        this.$Util.checkAppLinkPageShow(PUSH_ACTION.TEAM_DETAIL, this.teamIdx);

        if (this.from_screen === SOCCER_HOW_TEAM_DETAIL_FROM_SCREEN.FROM_REQUEST_JOIN_TEAM_SELECTOR) {
            this.$refs.soccer_team_detail_wrap.parentElement.style.zIndex = 301;
        }
    },
    created() {
        this.likeTeam = this.$Once(this.likeTeam)
        this.unLikeTeam = this.$Once(this.unLikeTeam)
        this.getSoccerTeamDetail()

        if(this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().is_temp_coach === '0'){
            this.screen_stay_settimeout = setTimeout(async() => {
                const parameters = {};
                parameters.trigger_type = TRIGGER_TYPE.TRANSFER_MARKET_STAY;
                this.$Axios.post('/api/member/trigger/save', parameters)
            }, 1000 * 300);
        }
    }
}
</script>

<style scoped>
.common_box_shadow {
    box-shadow: 0px 0px 10px 0px #0000001A;
    background-color: #fff;
    padding: 20px 12px;
    border-radius: 24px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.background_image_wrapper {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    z-index: -1;
    opacity: 0.2;
    filter: blur(100px);
}

.common_class {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    height: 60px;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 700;
    background: linear-gradient(90deg, #FF7111 0%, #EABB56 50%, #FFC39A 100%);
}

.coach_class {
    width: 177px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    height: 60px;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 700;
    background: linear-gradient(90deg, #FF7111 0%, #EABB56 50%, #FFC39A 100%);
}

.logo_wrapper {
    width: 75px; 
    height: 75px; 
    box-shadow: 1px 1px 4px 0px #00000033; 
    background-color: #fff; 
    border-radius: 9px; 
    overflow: hidden; 
    display: flex; 
    justify-content: center; 
    align-items: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -38px;
}

.tab_btn {
    flex: 1; 
    text-align: center;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    border-bottom: 1px solid #d9d9d9;
    color: #909090;
}

.active {
    border-bottom: 2px solid var(--color-main);
    padding-bottom: 16px;
    color: var(--color-main);
}

.title {
    font-weight: 700; 
    line-height: 24px;
}

.lead_goal {
    background-color: #EFEFEF; 
    border-radius: 50%; 
    width: 24px; 
    height: 24px; 
    display: flex; 
    align-items: center;
    justify-content: center; 
    font-size: 12px; 
    font-weight: 700; 
}

.show_whole {
    font-size: 12px; 
    font-weight: 500; 
    display: flex; 
    gap: 6px; 
    align-items: center;
}

.border_common {
    position: absolute;
    width: 2px;
    height: 25px;
    background-color: #d9d9d9;
    bottom: -26px;
    left: 50%;
    transform: translateX(-50%)
}

.border_top {
    position: absolute;
    width: 2px;
    height: 7px;
    background-color: #d9d9d9;
    top: -8px;
    left: 50%;
    transform: translateX(-50%)
}

.border_bottom {
    position: absolute;
    width: 2px;
    height: 8px;
    background-color: #d9d9d9;
    bottom: -9px;
    left: 50%;
    transform: translateX(-50%)
}

.main_info_item {
    border-radius: 12px;
    padding: 12px;
    background: #fff;
    border: 1px solid #ececec;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.main_info_item.opened {
    background: #F8F9FA;
}

.main_info_header {
    display: flex;
    gap: 5px;
    align-items: center;
}

.main_info_arrow {
    transform: rotate(90deg);
    transition: transform 0.3s ease;
}

.main_info_arrow.opened {
    transform: rotate(-90deg);
}

.main_info_body {
    display: grid;
    transition: grid-template-rows 0.3s ease;
}

.main_info_divider {
    margin-top: 12px;
    border-top: 1px solid #d9d9d9;
}

.main_info_contents {
    margin-top: 10px;
    font-size: 12px;
    line-height: 18px;
    font-weight: 500;
    color: #808080;
    text-align: left;
}
</style>